"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _reactRouterDom = require("react-router-dom");
var _reactResponsive = _interopRequireDefault(require("react-responsive"));
var _reactTooltip = _interopRequireDefault(require("react-tooltip"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var SpinErrorTable = /*#__PURE__*/function (_React$Component) {
  _inherits(SpinErrorTable, _React$Component);
  var _super = _createSuper(SpinErrorTable);
  function SpinErrorTable(props) {
    var _this;
    _classCallCheck(this, SpinErrorTable);
    _this = _super.call(this, props);
    _this.state = {
      expanded: false
    };
    return _this;
  }
  _createClass(SpinErrorTable, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var errorValueToolTip = this.props.i18next.t("lable.errorTooltip1");
      var optimalActionToolTip = this.props.i18next.t("lable.errorTooltip2");
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_reactTooltip["default"], null), /*#__PURE__*/_react["default"].createElement("table", {
        className: "spinRepo_table",
        style: {
          width: "100%",
          fontSize: "14px",
          color: '#020202',
          backgroundColor: "#9797970d"
        }
      }, /*#__PURE__*/_react["default"].createElement("thead", {
        className: "bottom hideMobile"
      }, /*#__PURE__*/_react["default"].createElement("tr", {
        className: ""
      }, /*#__PURE__*/_react["default"].createElement("th", {
        className: "spinError-th spin-dateHoleCardColWidth hideOrShowPopInMobile " + (this.props.ismodal ? '' : 'displayProp')
      }, this.props.i18next.t("lable.dateAndtime")), /*#__PURE__*/_react["default"].createElement("th", {
        className: "spinError-th spin-dateHoleCardColWidth"
      }, this.props.i18next.t("lable.pocketCards")), /*#__PURE__*/_react["default"].createElement("th", {
        width: "12%",
        className: "spinError-th hideOrShowPopInMobile "
      }, this.props.i18next.t("lable.Position")), this.props.ismodal && /*#__PURE__*/_react["default"].createElement("th", {
        width: "12%",
        className: "spinError-th hideOrShowPopInMobile "
      }, this.props.i18next.t("lable.errorType")), /*#__PURE__*/_react["default"].createElement("th", {
        width: "12%",
        className: "spinError-th hideOrShowPopInMobile "
      }, this.props.i18next.t("lable.errorValue"), "\xA0", /*#__PURE__*/_react["default"].createElement("i", {
        style: {
          color: '#DE460F'
        },
        className: "fa fa-question-circle",
        "data-tip": errorValueToolTip,
        "aria-hidden": "true"
      })), /*#__PURE__*/_react["default"].createElement("th", {
        width: "12%",
        className: "spinError-th hideOrShowPopInMobile " + (this.props.ismodal ? '' : 'displayProp')
      }, this.props.i18next.t("lable.myAction")), /*#__PURE__*/_react["default"].createElement("th", {
        width: "30%",
        className: "spinError-th hideOrShowPopInMobile " + (this.props.ismodal ? '' : 'displayProp'),
        style: {
          width: "auto"
        }
      }, this.props.i18next.t("lable.optimalAction"), "\xA0", /*#__PURE__*/_react["default"].createElement("i", {
        style: {
          color: '#DE460F'
        },
        className: "fa fa-question-circle",
        "data-tip": optimalActionToolTip,
        "aria-hidden": "true"
      })), !this.props.ismodal ? /*#__PURE__*/_react["default"].createElement(_reactResponsive["default"], {
        maxWidth: 991
      }, /*#__PURE__*/_react["default"].createElement("th", {
        width: "38%",
        className: "spinError-th "
      }, this.props.i18next.t("lable.profitActions"))) : /*#__PURE__*/_react["default"].createElement("th", {
        width: "38%",
        className: "spinError-th propsForMob"
      }, this.props.i18next.t("lable.profitActions")), /*#__PURE__*/_react["default"].createElement("th", {
        width: "3.78%",
        className: "spinError-th"
      }))), /*#__PURE__*/_react["default"].createElement("tbody", {
        className: ""
      }, this.props.errorHands.hands.map(function (key, index) {
        return /*#__PURE__*/_react["default"].createElement("tr", {
          className: "bottom",
          key: index
        }, /*#__PURE__*/_react["default"].createElement("td", {
          className: "spinError-tr hideOrShowPopInMobile " + (_this2.props.ismodal ? '' : 'displayProp')
        }, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
          style: {
            color: '#828282'
          }
        }, (0, _moment["default"])(key.dataTime.value).format("HH:mm"))), /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
          style: {
            color: '#828282'
          }
        }, (0, _moment["default"])(key.dataTime.value).format("DD/MM/YYYY")))), /*#__PURE__*/_react["default"].createElement("td", {
          className: "spinError-tr ",
          style: {
            minWidth: "75px"
          }
        }, key.PocketCards.map(function (cardUrl, i) {
          return cardUrl ? /*#__PURE__*/_react["default"].createElement("img", {
            key: i,
            src: cardUrl,
            className: "spinErrorCards"
          }) : /*#__PURE__*/_react["default"].createElement("div", {
            className: "spinErrorCards"
          });
        })), /*#__PURE__*/_react["default"].createElement("td", {
          className: "spinError-tr hideOrShowPopInMobile"
        }, key.positions, "\xA0", /*#__PURE__*/_react["default"].createElement("i", {
          style: {
            color: '#DE460F'
          },
          className: "fa fa-question-circle",
          "data-tip": key.toolTip,
          "aria-hidden": "true"
        })), _this2.props.ismodal && /*#__PURE__*/_react["default"].createElement("td", {
          className: "spinError-tr hideOrShowPopInMobile "
        }, key.errorType, "\xA0", /*#__PURE__*/_react["default"].createElement("i", {
          style: {
            color: '#DE460F'
          },
          className: "fa fa-question-circle",
          "data-tip": key.errortoolTip,
          "aria-hidden": "true"
        })), /*#__PURE__*/_react["default"].createElement("td", {
          className: "spinError-tr hideOrShowPopInMobile "
        }, key.errorValue), /*#__PURE__*/_react["default"].createElement("td", {
          className: "spinError-tr hideOrShowPopInMobile " + (_this2.props.ismodal ? '' : 'displayProp')
        }, key.heroAction), /*#__PURE__*/_react["default"].createElement("td", {
          className: "spinError-tr hideOrShowPopInMobile " + (_this2.props.ismodal ? '' : 'displayProp')
        }, key.optimalAction), !_this2.props.ismodal ? /*#__PURE__*/_react["default"].createElement("tr", {
          className: "displayTablets"
        }, /*#__PURE__*/_react["default"].createElement("td", {
          style: {
            color: key.profit < 0 ? '#828282' : '#6DB92C',
            paddingTop: '13.87px'
          }
        }, /*#__PURE__*/_react["default"].createElement("div", null, key.profit < 0 ? key.profit : '+' + key.profit)), /*#__PURE__*/_react["default"].createElement("tr", {
          className: "displayTablets"
        }, /*#__PURE__*/_react["default"].createElement("td", null, /*#__PURE__*/_react["default"].createElement("div", null, _this2.props.i18next.t("lable.myAction"), ":", key.heroAction))), /*#__PURE__*/_react["default"].createElement("tr", {
          className: "displayTablets"
        }, /*#__PURE__*/_react["default"].createElement("td", {
          style: {
            paddingBottom: '15.55px'
          }
        }, /*#__PURE__*/_react["default"].createElement("div", null, _this2.props.i18next.t("lable.optimalAction"), ":", key.optimalAction)))) : /*#__PURE__*/_react["default"].createElement("tr", {
          className: "displayTablets propsForMob"
        }, /*#__PURE__*/_react["default"].createElement("td", {
          style: {
            color: key.profit < 0 ? '#828282' : '#6DB92C',
            paddingTop: '13.87px'
          }
        }, /*#__PURE__*/_react["default"].createElement("div", null, key.profit < 0 ? key.profit : '+' + key.profit)), /*#__PURE__*/_react["default"].createElement("tr", {
          className: "displayTablets"
        }, /*#__PURE__*/_react["default"].createElement("td", null, /*#__PURE__*/_react["default"].createElement("div", null, _this2.props.i18next.t("lable.myAction"), ":", key.heroAction))), /*#__PURE__*/_react["default"].createElement("tr", {
          className: "displayTablets"
        }, /*#__PURE__*/_react["default"].createElement("td", {
          style: {
            paddingBottom: '15.55px'
          }
        }, /*#__PURE__*/_react["default"].createElement("div", null, _this2.props.i18next.t("lable.optimalAction"), ":", key.optimalAction)))), /*#__PURE__*/_react["default"].createElement("td", {
          className: "spinError-tr",
          style: {
            width: "40px"
          }
        }, /*#__PURE__*/_react["default"].createElement("i", {
          className: "fa fa-play-circle  spinPlay-btn",
          style: {
            "float": "right"
          },
          onClick: function onClick(e) {
            e.preventDefault();
            _this2.props.handReplayerOpen(key);
          }
        })));
      }))));
    }
  }]);
  return SpinErrorTable;
}(_react["default"].Component);
var _default = (0, _reactRouterDom.withRouter)(SpinErrorTable);
exports["default"] = _default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/mygame-components/dist/ReportCards/SpinErrorTable.js
 ** module id = 659
 ** module chunks = 0
 **/